<template>
    <div>
        <polls-grid
                :items="items"
                :total="total"
                :loading="loading"
                @paginate="onPaginate"
                @editItem="editItem"
                @deleteItem="deleteItem"
                @copyItem="copyItem"
        >
        </polls-grid>

        <v-dialog v-model="dialog" 
                  fullscreen 
                  persistent
                  hide-overlay 
                  transition="dialog-bottom-transition">
            <add-edit-poll
                    v-if="dialog"
                    @shouldCloseAddEdit="dialog = false"
                    @addedEdited="addedEdited"
                    :edit-mode="editMode"
                    :edit-id="editId"
            ></add-edit-poll>
        </v-dialog>

        <v-dialog v-model="dialogRemove" max-width="290">
            <delete-confirm
                    @shouldCloseDeleteConfirm="dialogRemove = false"
                    @removed="removed"
                    :delete-id="deleteId"
            >
            </delete-confirm>
        </v-dialog>

        <v-dialog v-model="dialogCopy" max-width="290">
            <copy-confirm
                    @shouldCloseDeleteConfirm="dialogCopy = false"
                    @copied="copied"
                    :copy-id="copyId"
            >
            </copy-confirm>
        </v-dialog>

        <v-btn
                color="primary"
                dark
                fixed
                bottom
                right
                fab
                @click="addItem()"
        >
            <v-icon>add</v-icon>
        </v-btn>
    </div>
</template>
<script>
    import HttpService from "../../../../HttpService";
    import PollsGrid from "./PollsGrid";
    import {objectQueryStringify} from "../../../../helpers/querystringHelper";
    import AddEditPoll from "./AddEditPoll";
    import DeleteConfirm from "./DeleteConfirm";
    import CopyConfirm from "./CopyConfirm";

    export default {
        components: {
            PollsGrid,
            AddEditPoll,
            DeleteConfirm,
            CopyConfirm
        },
        methods: {
            getItems(queryParams) {
                this.loading = true;

                HttpService.getInstance()
                    .get(`pollsAdmin?${queryParams}`)
                    .then(faculties => {
                        this.items = faculties.items;
                        this.total = faculties.total;
                        this.loading = false;
                    })
            },
            onPaginate(paginationData) {
                if (this.items.length === 0 || 
                    JSON.stringify(this.pagination) !== JSON.stringify(paginationData)) {
                    this.getItems(objectQueryStringify(paginationData));
                }

                this.pagination = paginationData;
            },
            addItem() {
                this.dialog = true;
                this.editId = null;
                this.editMode = false;
            },
            editItem(itemId) {
                this.dialog = true;
                this.editId = itemId;
                this.editMode = true;
            },
            addedEdited() {
                this.dialog = false;
                this.editId = null;

                this.getItems(objectQueryStringify(this.pagination));
            },
            deleteItem(itemId) {
                this.dialogRemove = true;
                this.deleteId = itemId;
            },
            copyItem(itemId) {
                this.dialogCopy = true;
                this.copyId = itemId;
            },
            removed() {
                this.dialogRemove = false;
                this.deleteId = null;

                this.getItems(objectQueryStringify(this.pagination));
            },
            copied() {
                this.dialogCopy = false;
                this.copyId = null;

                this.getItems(objectQueryStringify(this.pagination));
            },
        },
        data: () => {
            return {
                dialog: false,
                dialogRemove: false,
                dialogCopy: false,
                editId: null,
                editMode: false,
                deleteId: null,
                copyId: null,
                items: [],
                total: null,
                loading: false,
                pagination: {
                    totalItems: 0,
                },
            }
        }
    }
</script>